function TitleArea(props: any) {
  let myProps = {
    Style: null,
    todo_info: null,
    ...props
  };
  let Style = myProps.Style;
  let todo_info = myProps.todo_info;

  return (
    <div className={Style.popup_titile_wrap}>
      {todo_info &&
        <div className={Style.title_container}>
          <div className={Style.title_content}>
            <div className={Style.title_main}>
              {todo_info.a_title}
            </div>
          </div>
        </div>
      }
    </div>
  );
};
export default TitleArea;